
import { TableRow, Table, TableHead, TableBody, Paper, TableContainer } from "@mui/material";
import { DetailRow } from "./DetailRow";
import LoadingZone from "../../../components/loading-zone/LoadingZone";
import { useQueryNotifications } from "../../../queries/UseQueryNotifications";
import { useTankRelationshipData } from "../../../queries/tank-relationship-data/UseTankRelationshipData";
import { useRouteContext } from "../../../hooks/use-route-context/UseRouteContext";
import TankBatteryTableViewUtils from "./TankBatteryTableViewUtils";
import { HeaderCell } from "../common/HeaderCell";
import { TankRelationshipsContainer } from "../common/TankRelationshipsContainer";
import { TankRelationshipStateType } from "../TankRelationshipsViewState";
import { useTranslation } from "react-i18next";
import NoData from "../../../components/no-data/NoData";
import { forwardRef, Ref, useImperativeHandle, useMemo } from "react";
import { BaseActionEnum } from "../../action-menu/ActionMenuItem";


export type TankBatteryTableProps = {
    state: TankRelationshipStateType;

};

export type TankBatteryTableType = {
    executeAction: (action: BaseActionEnum) => void;
};



function TankBatteryTable({
    state,
}: TankBatteryTableProps, ref: Ref<unknown> | undefined) {

    const { t } = useTranslation();
    const routeContext = useRouteContext();

    const {data, status, refetch} = useQueryNotifications(useTankRelationshipData)({
        groupID: routeContext.groupID as number,
    });

    const models = useMemo(() => {
        return TankBatteryTableViewUtils.shapeData(data?.flatMap(o => o.tankBatteries) ?? [], state);
    }, [
        data,
        state
    ]);

    useImperativeHandle<unknown, TankBatteryTableType>(
        ref,
        () => ({
            executeAction: executeAction
        })
    );

    function executeAction(action: BaseActionEnum) {
        switch (action) {
            case BaseActionEnum.Refresh:
                refetch();
                break;
        }
    }


    return (

        <LoadingZone isLoading={status === 'loading'}>

            <TankRelationshipsContainer>
                {
                models.length > 0 &&                 
                <TableContainer component={Paper}>
                    <Table 
                        aria-label="collapsible table" 
                        stickyHeader={true} 
                        size="small"
                    >
                        <TableHead>
                            <TableRow>
                                <HeaderCell text={t('tankRelationships.displayName')} />
                                <HeaderCell align="right" text={t('tankRelationships.capacityFilled')} />
                                <HeaderCell align="right" text={t('tankRelationships.dailyOilProduction')} />
                                <HeaderCell align="right" text={t('tankRelationships.dailyWaterProduction')} hideDivider={true}/>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {models?.map((o) => (
                                <DetailRow key={o.id} item={o} expand={state.expanded} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                }

                {
                status === 'success' && models.length === 0 && 
                <NoData text={t('tankRelationships.nodata.text')} />
                }

            </TankRelationshipsContainer>

        </LoadingZone>


    )
    
}


export default forwardRef(TankBatteryTable);